var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"svg-wrap"},[_c('div',{staticClass:"bounce-off"},[_c('SvgIcon',{attrs:{"name":'face-' + _vm.active}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }